import { render, staticRenderFns } from "./MarketingAuster.vue?vue&type=template&id=0bba9dda&scoped=true"
import script from "./MarketingAuster.vue?vue&type=script&lang=js"
export * from "./MarketingAuster.vue?vue&type=script&lang=js"
import style0 from "./MarketingAuster.vue?vue&type=style&index=0&id=0bba9dda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bba9dda",
  null
  
)

export default component.exports